module.exports = __webpack_public_path__ + "img/heatmap.a6efc759.jpg";